import { inject, NgModule } from '@angular/core';
import { StateDeclaration, UIRouter, UIRouterModule } from '@uirouter/angular';

import type { ModuleStatesDeclaration } from 'types/StateDeclaration';

import { EmailChangeConfirmationComponent } from './containers/email-change-confirmation/email-change-confirmation.component';
import { FindCompanyComponent } from './containers/find-company/find-company.component';
import { FindCompanyEmailSentComponent } from './containers/find-company/email-sent/find-company-email-sent.component';
import browserHelper from '@utils/browser-helper';
import { featureFlags } from '@utils/feature-flags';
import { AppInitializedEmitterService } from '@shared/services/app-initialized-emitter.service';
import { first } from 'rxjs/operators';
import { RegisterBlockedComponent } from './containers/register-new/blocked/register-blocked.component';
import { RegisterBlockedComponent as RegisterBlockedOldComponent } from './containers/register/blocked/register-blocked.component';
import { RegisterEmailSentComponent } from './containers/register-new/email-sent/register-email-sent.component';
import { RegisterEmailSentComponent as RegisterEmailSentOldComponent } from './containers/register/email-sent/register-email-sent.component';
import { RegisterComponent } from './containers/register-new/register.component';
import { RegisterComponent as RegisterOldComponent } from './containers/register/register.component';

const routes: ModuleStatesDeclaration = {
  states: [
    {
      name: 'email-change-confirmation',
      url: '/email-change-confirmation?u&t',
      component: EmailChangeConfirmationComponent,
      data: {
        bodyClass: ['app-footer', 'app-white']
      }
    },
    {
      name: 'find-company',
      url: '/find-company',
      component: FindCompanyComponent,
      data: {
        bodyClass: ['app-footer', 'app-white']
      }
    },
    {
      name: 'find-company-email-sent',
      url: '/find-company/email-sent',
      params: {
        email: ''
      },
      component: FindCompanyEmailSentComponent,
      data: {
        bodyClass: ['app-footer', 'app-white']
      }
    }
  ]
};

@NgModule({
  imports: [UIRouterModule.forChild(routes)]
})
export class AuthRoutingModule {
  private appInitializedEmitterSrv = inject(AppInitializedEmitterService);
  private router = inject(UIRouter);

  constructor() {
    this.appInitializedEmitterSrv
      .isAppInitialized()
      .pipe(first())
      .subscribe(() => this.addRoutesByFt());
  }

  private addRoutesByFt() {
    const newRegistrationFt = featureFlags.isOn('Registration.LoginExperienceRedesign');
    const registerComponentsFooter = newRegistrationFt ? ['app-white'] : ['app-footer'];

    const states = [
      {
        name: 'register-blocked',
        url: '/register/blocked',
        component: newRegistrationFt ? RegisterBlockedComponent : RegisterBlockedOldComponent,
        data: {
          bodyClass: registerComponentsFooter
        }
      },
      {
        name: 'register',
        url: '/register',
        component: newRegistrationFt ? RegisterComponent : RegisterOldComponent,
        data: {
          bodyClass: registerComponentsFooter,
          showHeader: !newRegistrationFt,
          ignoreStateAsTitle: newRegistrationFt ? true : false
        }
      },
      {
        name: 'register-email-sent',
        url: '/register/email-sent',
        params: {
          email: ''
        },
        component: newRegistrationFt ? RegisterEmailSentComponent : RegisterEmailSentOldComponent,
        data: {
          bodyClass: () => (browserHelper.isMobile ? 'app-white' : registerComponentsFooter)
        }
      }
    ];

    states.forEach(state => {
      this.router.stateRegistry.register(state as StateDeclaration);
    });
  }
}
